import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styles from './styles.scss';
import { DateCarousel } from 'widget/event_components/Ticket/components/Datetime/components/DateCarousel';
import Divider from '@mui/material/Divider';
import { ColorDescription } from 'widget/event_components/Ticket/components/Datetime/ColorDescription';
import moment from 'moment';
import Periods from 'widget/event_components/Ticket/components/Datetime/components/Periods';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { List } from 'immutable';

class DateTimeEntriesFactory {
  constructor(occurrences) {
    this.occurrences = occurrences;
  }

  sortTimes(timeEntries) {
    return timeEntries.sort((a, b) => {
      const firstIterateDate = a.get('start_date');
      const secondIterateDate = b.get('start_date');

      if (moment(firstIterateDate).isAfter(secondIterateDate)) return 1;
      if (moment(firstIterateDate).isBefore(secondIterateDate)) return -1;

      return 0;
    });
  }

  timeEntriesIterator(timeEntries) {
    return this.sortTimes(timeEntries);
  }

  occurrencesIterator() {
    return this.sortTimes(this.occurrences).map((occurrence) => ({
      start: moment(occurrence.get('start_date')).tz(occurrence.get('timezone')),
      end: moment(occurrence.get('end_date')).tz(occurrence.get('timezone')),
      id: occurrence.get('id'),
      timeEntries: this.timeEntriesIterator(occurrence.get('time_entries')),
    }));
  }

  getEntries() {
    return this.occurrencesIterator();
  }
}

const BackToDatePlate = ({ occurrenceDate }) => (
  <div className={styles.backToDateContainer}>
    <div className={styles.dateInPlate}>
      <CalendarMonthIcon />
      {occurrenceDate.format('ddd, D MMMM YYYY')}
    </div>
  </div>
);

export const CommonView = ({ event, occurrences = List(), setTickets, setEvent, settings, occurrenceDate, onClickBack, setOccurrencesDate }) => {
  const [selectedOccurrence, setSelectedOccurrence] = useState();

  useEffect(() => {
    if (occurrenceDate) {
      occurrences.forEach((occurrence) => {
        const choiceDate = moment(occurrenceDate.tz(occurrence.get('timezone')));
        const eventDate = moment(moment(occurrence.get('start_date')).tz(occurrence.get('timezone')));

        if (choiceDate.isSame(eventDate, 'day')) {
          setSelectedOccurrence(occurrence.get('id'));
        }
      });
    } else if (occurrences.first && occurrences.first()) {
      setSelectedOccurrence(occurrences.first().get('id'));
    }
  }, [occurrences, occurrenceDate]);

  const entries = useMemo(() => new DateTimeEntriesFactory(occurrences).getEntries(), [occurrences, occurrenceDate]);

  const handleDateOnClick = useCallback((id) => {
    setSelectedOccurrence(id);
  }, []);

  const currentEntries = useMemo(() => entries.find((record) => record.id === selectedOccurrence), [selectedOccurrence]);
  return (
    <div className={styles.wrapper}>
      {occurrenceDate ? (
        <BackToDatePlate occurrenceDate={occurrenceDate} onClickBack={onClickBack} />
      ) : (
        <DateCarousel dateTimeEntries={entries} selectedOccurrence={selectedOccurrence} onClickOccurrence={handleDateOnClick} />
      )}
      <Divider className={styles.divider} variant="fullWidth" />
      <Periods
        setOccurrencesDate={setOccurrencesDate}
        event={event}
        setEvent={setEvent}
        setTickets={setTickets}
        selectedOccurrence={currentEntries}
        settings={settings}
        key={event.get('id')}
      />
      <ColorDescription settings={settings} className={styles.colorDescriptionWrapper} />
    </div>
  );
};
